import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/styles";

import DupontCheckbox from "components/DupontCheckbox";

const useStyles = makeStyles(theme => ({
  checkboxContainer: { display: "inline-block", verticalAlign: "middle" }
}));

const ChartTagCheckboxRenderer = props => {
  const classes = useStyles();
  const { field } = props;
  const [isChecked, setIsChecked] = useState(props.node.data.Show || props.node.isSelected());
  const checkboxVal = props.node.data.Show || props.node.isSelected();

  useEffect(() => setIsChecked(checkboxVal), [checkboxVal]);
  const selectionChangeHandler = val => props.node.setSelected(val);

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox checked={isChecked} onChange={selectionChangeHandler} />
    </span>
  );
};

export default ChartTagCheckboxRenderer;
